import Header from "./Header";
import { Confirm } from "../../components/shared";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import useAppLogout from "../../hooks/useAppLogout";
import { draftIdentityFromIdToken, draftIsIncomplete, listDrafts } from "../../utils/lineDraftStorage";

const HeaderContainer = ({
    isSmallScreen,
    onToggle,
    setLogout = () => {},
    mobileCollapse, // True(show nav) / False(hide nav)-
}) => {
    const dispatch = useDispatch();
    const logout = useAppLogout();
    const { t } = useTranslation();
    const idToken = useSelector((state) => state?.auth?.user?.idToken);

    const onLogoutClick = () => {
        // Line drafts (LT-3597) are discarded at logout, so say which ones before asking.
        const identity = draftIdentityFromIdToken(idToken);
        const drafts = identity ? listDrafts(identity) : [];
        Confirm({
            title: t("admin.equipment.lineDraft.logoutTitle"),
            icon: "",
            content: (
                <div>
                    <p>{t("admin.equipment.lineDraft.logoutBody")}</p>
                    {drafts.length > 0 && (
                        <>
                            <p>{t("admin.equipment.lineDraft.logoutDraftsWarning", { count: drafts.length })}</p>
                            <ul>
                                {drafts.map((draft) => (
                                    <li key={`${draft.facilityId}-${draft.cellId}`}>
                                        {draft.facilityName} · {draft.cellName} · {t("admin.equipment.lineDraft.draftItems", { count: draft.items.length })}
                                        {draftIsIncomplete(draft) && ` — ${t("admin.equipment.lineDraft.incompleteBadge")}`}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            ),
            onOk() {
                setLogout(); // Reset the Side Nav Menu to true/closed-
                return logout(dispatch);
            },
            onCancel() {},
            okText: t("admin.equipment.lineDraft.logoutYes"),
            cancelText: t("admin.equipment.lineDraft.logoutNo"),
            className: "isCancel",
        });
    };

    return (
        <Header
            mobile={isSmallScreen}
            onLogoutClick={onLogoutClick}
            onToggle={onToggle}
            mobileCollapse={mobileCollapse} // True(show nav) / False(hide nav)-
        />
    );
};

export default HeaderContainer;
